import React from "react"
import { MainColumn } from "../MainColumn"
import { Content } from "../Content"
import { LandingText, ArticleDetails } from "./style"
import moment from "moment"
import NewsFilter from "./NewsFilter"
import { Link } from "gatsby"

const InternalPage = ({
  content,
  landing,
  title,
  excerpt,
  article,
  author,
  date,
  category,
  categories,
  news,
  staff,
  setFilter,
  setCurrentPage,
  readingTime,
}) => {
  return (
    <MainColumn>
      {landing ? (
        <LandingText>
          <h1 dangerouslySetInnerHTML={{ __html: title }} />
          <p dangerouslySetInnerHTML={{ __html: excerpt }} />
          {(news || staff) && (
            <NewsFilter
              categories={categories}
              setFilter={setFilter}
              setCurrentPage={setCurrentPage}
              staff={staff}
            />
          )}
        </LandingText>
      ) : null}

      {article && (
        <ArticleDetails>
          <span className="category">
            <Link
              to={`/expert-news-views/?f=${
                category.slug === "uncategorized" ? "all" : category.slug
              }`}
              dangerouslySetInnerHTML={{ __html: category.name }}
            />
          </span>
          <div>
            By <span className="author">{author.name}</span>/
            <span className="date">{moment(date).format("DD MMM YYYY")}</span>
            {readingTime?.readingTime && (
              <>
                /<span className="reading">{readingTime?.readingTime}</span>
              </>
            )}
          </div>
        </ArticleDetails>
      )}

      {content && <Content landing={landing} content={content} />}
    </MainColumn>
  )
}

export default InternalPage
